// Service type tag colours, matching the mobile app (fieldnexus-expo jobCardTheme).
export const SERVICE_TYPE_FALLBACK_COLOR = "#9AA5B5";
const DARK_TEXT = "#022047";
const LIGHT_TEXT = "#FFFFFF";

// Colours are stored as "RRGGBB" by the API but may also arrive with a "#".
export const normalizeHex = (color) => {
  if (!color) return null;
  let hex = String(color).trim().replace(/^#+/, "");
  if (/^[0-9a-f]{3}$/i.test(hex)) {
    hex = hex.split("").map((c) => c + c).join("");
  }
  return /^[0-9a-f]{6}$/i.test(hex) ? `#${hex.toUpperCase()}` : null;
};

const luminance = (hex) => {
  const [r, g, b] = [1, 3, 5].map((i) => {
    const c = parseInt(hex.substr(i, 2), 16) / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

const contrast = (a, b) => {
  const [hi, lo] = [luminance(a), luminance(b)].sort((x, y) => y - x);
  return (hi + 0.05) / (lo + 0.05);
};

// Solid fill in the service type's own colour; white text only where it stays
// readable, dark navy otherwise. Pale fills get a border so they don't vanish
// on white rows.
export const serviceTypeColors = (color) => {
  const background = normalizeHex(color) || SERVICE_TYPE_FALLBACK_COLOR;
  const text = contrast(background, LIGHT_TEXT) >= 2.6 ? LIGHT_TEXT : DARK_TEXT;
  const border = luminance(background) > 0.75 ? "rgba(2, 32, 71, 0.2)" : background;
  return { background, text, border };
};

export const serviceTypeTagStyle = (color) => {
  const { background, text, border } = serviceTypeColors(color);
  return {
    backgroundColor: background,
    color: text,
    boxShadow: `inset 0 0 0 1px ${border}`,
    fontWeight: 600,
  };
};
